import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar recursos de tradução
import enCommon from './resources/en/common.json';
import enAuth from './resources/en/auth.json';
import enPacks from './resources/en/packs.json';
import enCategories from './resources/en/categories.json';
import enTags from './resources/en/tags.json';
import enLearnings from './resources/en/learnings.json';
import enProfiles from './resources/en/profiles.json';
import enAnalytics from './resources/en/analytics.json';
import enContracts from './resources/en/contracts.json';
import enHighlights from './resources/en/highlights.json';
import enCollections from './resources/en/collections.json';
import enPayments from './resources/en/payments.json';
import enReceivables from './resources/en/receivables.json';
import enReceivableShareConfigs from './resources/en/receivable-share-configs.json';
import enReceivableSnapshots from './resources/en/receivable-snapshots.json';
import enNavigation from './resources/en/navigation.json';
import enPresets from './resources/en/presets.json';
import enReceivablesComponents from './resources/en/receivables-components.json';
import enPaymentsComponents from './resources/en/payments-components.json';
import enLgpd from './resources/en/lgpd.json';
import ptBRCommon from './resources/pt-BR/common.json';
import ptBRAuth from './resources/pt-BR/auth.json';
import ptBRPacks from './resources/pt-BR/packs.json';
import ptBRCategories from './resources/pt-BR/categories.json';
import ptBRTags from './resources/pt-BR/tags.json';
import ptBRLearnings from './resources/pt-BR/learnings.json';
import ptBRProfiles from './resources/pt-BR/profiles.json';
import ptBRAnalytics from './resources/pt-BR/analytics.json';
import ptBRContracts from './resources/pt-BR/contracts.json';
import ptBRHighlights from './resources/pt-BR/highlights.json';
import ptBRCollections from './resources/pt-BR/collections.json';
import ptBRPayments from './resources/pt-BR/payments.json';
import ptBRReceivables from './resources/pt-BR/receivables.json';
import ptBRReceivableShareConfigs from './resources/pt-BR/receivable-share-configs.json';
import ptBRReceivableSnapshots from './resources/pt-BR/receivable-snapshots.json';
import ptBRNavigation from './resources/pt-BR/navigation.json';
import ptBRPresets from './resources/pt-BR/presets.json';
import ptBRReceivablesComponents from './resources/pt-BR/receivables-components.json';
import ptBRPaymentsComponents from './resources/pt-BR/payments-components.json';
import ptBRLgpd from './resources/pt-BR/lgpd.json';
import esCommon from './resources/es/common.json';
import esAuth from './resources/es/auth.json';
import esPacks from './resources/es/packs.json';
import esCategories from './resources/es/categories.json';
import esTags from './resources/es/tags.json';
import esLearnings from './resources/es/learnings.json';
import esProfiles from './resources/es/profiles.json';
import esAnalytics from './resources/es/analytics.json';
import esContracts from './resources/es/contracts.json';
import esHighlights from './resources/es/highlights.json';
import esCollections from './resources/es/collections.json';
import esPayments from './resources/es/payments.json';
import esReceivables from './resources/es/receivables.json';
import esReceivableShareConfigs from './resources/es/receivable-share-configs.json';
import esReceivableSnapshots from './resources/es/receivable-snapshots.json';
import esNavigation from './resources/es/navigation.json';
import esPresets from './resources/es/presets.json';
import esReceivablesComponents from './resources/es/receivables-components.json';
import esPaymentsComponents from './resources/es/payments-components.json';
import esLgpd from './resources/es/lgpd.json';

i18n
  .use(LanguageDetector) // Detecta o idioma do navegador
  .use(initReactI18next) // Passa i18n para react-i18next
  .init({
    // Recursos de tradução
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        packs: enPacks,
        categories: enCategories,
        tags: enTags,
        learnings: enLearnings,
        profiles: enProfiles,
        analytics: enAnalytics,
        contracts: enContracts,
        highlights: enHighlights,
        collections: enCollections,
        payments: enPayments,
        receivables: enReceivables,
        'receivable-share-configs': enReceivableShareConfigs,
        'receivable-snapshots': enReceivableSnapshots,
        navigation: enNavigation,
        presets: enPresets,
        'receivables-components': enReceivablesComponents,
        'payments-components': enPaymentsComponents,
        lgpd: enLgpd,
      },
      'pt-BR': {
        common: ptBRCommon,
        auth: ptBRAuth,
        packs: ptBRPacks,
        categories: ptBRCategories,
        tags: ptBRTags,
        learnings: ptBRLearnings,
        profiles: ptBRProfiles,
        analytics: ptBRAnalytics,
        contracts: ptBRContracts,
        highlights: ptBRHighlights,
        collections: ptBRCollections,
        payments: ptBRPayments,
        receivables: ptBRReceivables,
        'receivable-share-configs': ptBRReceivableShareConfigs,
        'receivable-snapshots': ptBRReceivableSnapshots,
        navigation: ptBRNavigation,
        presets: ptBRPresets,
        'receivables-components': ptBRReceivablesComponents,
        'payments-components': ptBRPaymentsComponents,
        lgpd: ptBRLgpd,
      },
      es: {
        common: esCommon,
        auth: esAuth,
        packs: esPacks,
        categories: esCategories,
        tags: esTags,
        learnings: esLearnings,
        profiles: esProfiles,
        analytics: esAnalytics,
        contracts: esContracts,
        highlights: esHighlights,
        collections: esCollections,
        payments: esPayments,
        receivables: esReceivables,
        'receivable-share-configs': esReceivableShareConfigs,
        'receivable-snapshots': esReceivableSnapshots,
        navigation: esNavigation,
        presets: esPresets,
        'receivables-components': esReceivablesComponents,
        'payments-components': esPaymentsComponents,
        lgpd: esLgpd,
      },
    },
    
    // Idioma padrão
    fallbackLng: 'pt-BR',
    
    // Namespace padrão
    defaultNS: 'common',
    
    // Idiomas suportados
    supportedLngs: ['en', 'pt-BR', 'es'],
    
    // Detecção de idioma
    detection: {
      // Ordem de detecção
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache do idioma selecionado
      caches: ['localStorage'],
      // Chave no localStorage
      lookupLocalStorage: 'i18nextLng',
    },
    
    // Interpolação
    interpolation: {
      escapeValue: false, // React já protege contra XSS
    },
    
    // React
    react: {
      useSuspense: false, // Não usar Suspense (melhor para Vite)
    },
    
    // Debug (apenas em desenvolvimento)
    debug: import.meta.env.DEV,
  });

// Log para debug (apenas em desenvolvimento)
if (import.meta.env.DEV) {
  i18n.on('languageChanged', (lng) => {
    console.log('🌐 Idioma alterado para:', lng);
  });
}

export default i18n;


